import { palette } from './palette';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { spacing } from './spacing';
import { zIndex } from './zIndex';
import { MuiButton } from './components/MuiButton';
import { MuiTabs, MuiTab } from './components/MuiTabs';
import { MuiTable, MuiTableCell, MuiTableRow } from './components/MuiTable';
import { MuiDrawer } from './components/MuiDrawer';
import { MuiTooltip } from './components/MuiTooltip';
import { MuiDialog, MuiDialogActions, MuiDialogContent, MuiDialogTitle } from './components/MuiDialog';
import { MuiDateCalendar } from './components/MuiDateCalendar';
import { MuiBreadcrumbs } from './components/MuiBreadcrumbs';

const MuiAlert = {
  defaultProps: {
    variant: 'outlined',
  },
};

const MuiFormField = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '8px',
    },
  },
};

const MuiTextField = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '8px',
    },
  },
};

const MuiSelect = {
  defaultProps: {
    size: 'small',
  },
  styleOverrides: {
    root: {
      marginBottom: '8px',
    },
  },
};

/**
 * Creates theme overrides
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createThemeOverrides = (): Record<string, any> => {
  const components = {
    MuiAlert,
    MuiFormField,
    MuiTextField,
    MuiSelect,
    MuiButton: MuiButton(palette.primary, palette.custom.gray, palette.error, palette.common.white),
    MuiTabs,
    MuiTab,
    MuiTable,
    MuiTableCell,
    MuiTableRow,
    MuiDrawer: MuiDrawer(palette.custom.gray[25], palette.custom.gray[200], palette.custom.gray[700]),
    MuiTooltip,
    MuiDialog,
    MuiDialogActions,
    MuiDialogContent,
    MuiDialogTitle,
    MuiDateCalendar,
    MuiBreadcrumbs: MuiBreadcrumbs(
      palette.custom.gray[300],
      palette.custom.gray[600],
      palette.primary[700],
      typography.fontWeightRegular,
      typography.fontWeightMedium,
      typography.fontWeightSemiBold
    ),
  };

  return {
    breakpoints,
    palette,
    typography,
    zIndex,
    components,
    spacing,
  };
};

/**
 * Default theme overrides
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const themeOverrides: Record<string, any> = createThemeOverrides();
